import * as React from 'react';
import { SelectSingleHierarchy } from 'app/area/shared/translated-components';
import { LoadOptions } from 'app/types-shared';
import { SubscriberGroupPickerState, SubscriberGroupSinglePickerProps } from './types';

export class MergeSubscriberGroupSinglePicker extends React.PureComponent<SubscriberGroupSinglePickerProps, SubscriberGroupPickerState> {

  public readonly state: Readonly<SubscriberGroupPickerState> = { loadedOptions: {} };

  private onLoadOptions = (options: LoadOptions) => {
    this.props.onLoadOptions(options);
    this.setState({ loadedOptions: options });
  };

  public render() {

    const { id, label, valueItem, options, translation, showBackgroundColour, className, enableMultilineValidation,
      onChange, required, searchRequired, validation, readOnly, extraFooterButton, showSpinnerLabel, size, minLength,
      displayCategories, includeDisabledLabel, uncheckSelectItem } = this.props;

    return <div className={`col-lg-${size || 6} col-sm-12 ${className || ''}`}>
      <SelectSingleHierarchy
        componentId={id}
        className={undefined}
        label={label ? { text: label, required: !!required } : undefined}
        readOnly={readOnly}
        extraFooterButton={extraFooterButton}
        valueItem={valueItem}
        searchRequired={searchRequired}
        onChange={onChange}
        showBackgroundColour={showBackgroundColour}
        showSpinnerLabel={showSpinnerLabel}
        descriptionAllLevels={true}
        enableMultilineValidation={enableMultilineValidation}
        validation={validation}
        options={options?.values}
        fetching={options?.fetching}
        loadOptions={this.state.loadedOptions}
        onLoadOptions={this.onLoadOptions}
        displayCategories={displayCategories}
        includeDisabledLabel={includeDisabledLabel}
        uncheckSelectItem={uncheckSelectItem}
        minLength={minLength}
        placeholder={translation.search} />
    </div>;
  }
}
